import {
  EVENT_TYPE_NUTRITION_CONSULTATION,
  EVENT_TYPE_THERAPY_SESSION,
} from 'src/consumer/constants'

export const EVENT_REMINDER_THERAPY_REPORT_COMPLETION = 'therapy-report-completion'

export const THERAPY_REPORT_REMINDER_DEFAULT_EVENT_TYPES = [
  EVENT_TYPE_THERAPY_SESSION,
  EVENT_TYPE_NUTRITION_CONSULTATION,
]

export const THERAPY_REPORT_REMINDER_DEFAULT_COMMUNICATION_MODES = ['mail', 'whatsapp']

function normalizeArray(values, fallback) {
  return Array.isArray(values) && values.length > 0 ? values : fallback
}

export function getTherapyReportReminderSettings(practitionerSettings = {}) {
  const current =
    practitionerSettings?.eventReminderSettingsMap?.[EVENT_REMINDER_THERAPY_REPORT_COMPLETION] || {}

  return {
    reminderType: EVENT_REMINDER_THERAPY_REPORT_COMPLETION,
    enabled: Boolean(current.enabled),
    eventTypes: normalizeArray(
      current.eventTypes,
      THERAPY_REPORT_REMINDER_DEFAULT_EVENT_TYPES,
    ),
    communicationModes: normalizeArray(
      current.communicationModes,
      THERAPY_REPORT_REMINDER_DEFAULT_COMMUNICATION_MODES,
    ),
  }
}

export function buildTherapyReportReminderSettingsMap(practitionerSettings = {}, enabled) {
  const currentMap = practitionerSettings?.eventReminderSettingsMap || {}
  const current = getTherapyReportReminderSettings(practitionerSettings)

  return {
    ...currentMap,
    [EVENT_REMINDER_THERAPY_REPORT_COMPLETION]: {
      ...current,
      enabled: Boolean(enabled),
    },
  }
}
